import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { format, parseISO } from "date-fns";

@Component({
  selector: "app-constat-modal",
  templateUrl: "./constat-modal.component.html",
  styleUrls: ["./constat-modal.component.scss"],
  standalone: false,
})
export class ConstatModalComponent implements OnInit {
  type;
  mission;
  detail = {
    date: null,
    motif: null,
    commentaire: "",
    responsable: "",
  };
  listeMotifs = [];
  selectedDate;
  maxDate;
  minDate;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) {}

  ngOnInit() {
    this.type = this.navParams.get("type");
    this.mission = this.navParams.get("mission");
    this.detail.date = this.mission.fr_dateintervention;

    // Set minDate from navParams or use today as fallback
    this.minDate = this.navParams.get("mindate")
      ? format(parseISO(this.navParams.get("mindate")), "yyyy-MM-dd")
      : this.today();

    if (this.mission.fr_dateintervention) {
      let date = format(
        parseISO(this.mission.fr_dateintervention),
        "yyyy-MM-dd"
      );
      // Ensure selectedDate is not before minDate
      this.selectedDate = date < this.minDate ? this.minDate : date;
    } else {
      this.selectedDate = this.minDate;
    }

    if (!this.navParams.get("noend") && this.navParams.get("maxdate")) {
      this.maxDate = format(
        parseISO(this.navParams.get("maxdate")),
        "yyyy-MM-dd"
      );
    }

    if (this.mission) {
      if (this.type === "refuser") {
        this.listeMotifs = this.mission.motifsRefus;
        if (this.mission.motifsRefus) {
          setTimeout(() => {
            this.detail.motif = this.mission.fr_motifrefus;
            this.detail.commentaire = this.mission.fr_commentairemotifsrefus;
            this.detail.responsable = this.mission.fr_responsablerefus;
          }, 500);
        }
      } else if (this.mission.motifsReport) {
        this.listeMotifs = this.mission.motifsReport;
        this.detail.motif = this.mission.fr_motifreport;
        this.detail.commentaire = this.mission.fr_commentairemotifreport;
        if (this.mission.fr_datereport) {
          this.selectedDate = format(
            parseISO(this.mission.fr_datereport),
            "yyyy-MM-dd"
          );
        }
      }
    }
  }

  today() {
    return format(new Date(), "yyyy-MM-dd");
  }

  closeModal() {
    if (this.selectedDate) {
      this.detail.date = parseISO(this.selectedDate).toISOString();
    }
    this.modalCtrl.dismiss(this.detail);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
